import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'bcsc-digi-sso-login',
  templateUrl: './sso-login.component.html',
  styleUrls: ['./sso-login.component.scss'],
})
export class SsoLoginComponent implements OnInit {

  @Input() title = 'Login';
  @Input() isSSOLogin = false;
  @Output() onLogin = new EventEmitter();

  validateModuleForm!: FormGroup;
  displayPwd = false;

  constructor(
    private fb: FormBuilder,
    ) {

  }

  ngOnInit(): void {
    this.validateModuleForm = this.fb.group({
      username: [null, [Validators.required]], 
      password: [null, [Validators.required]],
    });
  }

  onUserLogin() {
    if (this.validateModuleForm.valid) {
      this.onLogin.emit(this.validateModuleForm.value);
    } else {
      Object.values(this.validateModuleForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

}
